import type { Locale } from 'antd/es/locale';
import enUS from 'antd/locale/en_US';

export const platformDatePickerDisplayFormat = 'MMM. Do, YYYY';
export const platformDateTimePickerDisplayFormat = `${platformDatePickerDisplayFormat} HH:mm:ss`;

export const platformLocale: Locale = {
    ...enUS,
    DatePicker: enUS.DatePicker
        ? {
              ...enUS.DatePicker,
              lang: {
                  ...enUS.DatePicker.lang,
                  fieldDateFormat: platformDatePickerDisplayFormat,
                  fieldDateTimeFormat: platformDateTimePickerDisplayFormat,
              },
          }
        : undefined,
};
